import { rowsPerPageOptionsValues } from "../utils";
import { Props } from "./interfaces";
import { TablePagination } from "./styles";
import { CUSTOM_PAGINATION_ID } from "./utils";

const CustomTablePagination = ({
  totalItems = 0,
  pageNumber = 0,
  handleChangePageNumber,
  rowsPerPageOptions = rowsPerPageOptionsValues,
  pageSize = 10,
  handleChangePageSize,
  outlined,
  labelRowsPerPage,
}: Props): JSX.Element => {
  return (
    <TablePagination
      component="div"
      outlined={outlined}
      count={totalItems}
      page={pageNumber}
      onPageChange={(_, pageNumber) => handleChangePageNumber(pageNumber)}
      rowsPerPageOptions={rowsPerPageOptions}
      rowsPerPage={pageSize}
      onRowsPerPageChange={(e) => handleChangePageSize && handleChangePageSize(+e.target.value)}
      labelRowsPerPage={labelRowsPerPage ?? "Rows per page"}
      id={CUSTOM_PAGINATION_ID}
    />
  );
};

export default CustomTablePagination;
